import "./App.css";
import Aboutsection from "./components/aboutsection";
import Contactus from "./components/contactus";
import CustomerSection from "./components/customerSection";
import Header from "./components/header";
import Projectsection from "./components/projectsection";
import Footer from "./footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Aboutsection />
      <Projectsection />
      <CustomerSection />
      <Contactus />
      <Footer />
    </div>
  );
}

export default App;
